import type { RouteRecordRaw } from 'vue-router'

export const photoModerationRouter: RouteRecordRaw[] = [
  {
    async beforeEnter() {
      // Reviewer endpoints are FE-first; serve them via MSW in dev so the queue
      // renders without a backend. Mirrors the staff route's mock bootstrap.
      if (
        import.meta.env.MODE === 'development' &&
        import.meta.env.VITE_ENABLE_MOCKS === 'true'
      ) {
        const { startMockWorker, isMockWorkerStarted } =
          await import('@/mocks/browser')
        if (!isMockWorkerStarted()) {
          await startMockWorker()
        }
      }
    },

    children: [
      {
        component: async () => import('../views/PhotoModerationView.vue'),
        meta: {
          authZ: ({ user }) => user.hasRole('pb:super'),
          title: 'photo-moderation.page.title',
        },
        name: 'photo-moderation.index',
        path: '',
      },
      {
        component: async () => import('../views/ReviewDetailView.vue'),
        meta: {
          authZ: ({ user }) => user.hasRole('pb:super'),
        },
        name: 'photo-moderation.detail',
        path: 'submission/:submissionId',
      },
    ],
    component: async () => import('../views/PhotoModerationLayout.vue'),
    meta: {
      authZ: ({ user }) => user.hasRole('pb:super'),
    },
    path: 'photo-moderation',
  },
]
